import { Theme } from "@mui/material";
import { maxHeight } from "@mui/system";

export const Variants = (theme: Theme) => {
  return {
    primary: {
      ".MuiButtonBase-root": {
        fontWeight: theme.fontWeights.semibold,

        color: theme.colors["neutral.50"],
        backgroundColor: theme.colors["neutral.800"],
        border: `2px solid ${theme.colors["neutral.800"]}`,
  
        "&.is-Selected": {
          border: `2px solid ${theme.colors["lime.500"]}`,
          color: theme.colors["lime.500"]
        },
  
        '&:hover': {
          backgroundColor: theme.colors["neutral.800"],
          border: `2px solid ${theme.colors["lime.500"]}`
        },
      }
    },
    secondary: {
      ".MuiButtonBase-root": {
        fontWeight: theme.fontWeights.medium,

        color: theme.colors["neutral.50"],
        backgroundColor: theme.colors["neutral.950"],
        border: `2px solid ${theme.colors["neutral.950"]}`,
  
        "&.is-Selected": {
          border: `2px solid ${theme.colors["lime.500"]}`,
          color: theme.colors["lime.500"]
        },
  
        '&:hover': {
          backgroundColor: theme.colors["neutral.950"],
          border: `2px solid ${theme.colors["lime.500"]}`
        },
      }
    }
  }
}

export const SizeStyles = (theme: Theme) => {
  return {
    sm: {
        fontSize: theme.fontSizes.sm,
        padding: `${theme.space._200} ${theme.space._300}`,
    },
    md: {
        fontSize: theme.fontSizes.md,
        padding: `${theme.space._300} ${theme.space._450}`,
    },
    lg: {
        fontSize: theme.fontSizes.lg,
        padding: `${theme.space._400} ${theme.space._450}`,
    },
  };
};